<script lang="ts" setup>
defineProps<{ isSelected: boolean }>()
</script>

<template>
  <div class="group/row h-8 min-w-full border-t-0 border-b border-border-subtle">
    <slot />
    <div
      data-test="empty-cell"
      class="relative inline-flex h-8 min-w-[100px] grow items-center justify-start border-b border-l border-border-subtle py-1.5 before:absolute before:size-full group-hover/row:before:bg-background-gray-subtlest"
      :class="isSelected ? 'bg-background-selected' : 'bg-background-transparent'"
    />
  </div>
</template>
